














































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {DialogRemove} from '@/helpers/dialog/DialogRemove'
import {TypeSms} from '@/model/resource/TypeSms'
import {TypeSmsCollection} from '@/model/collection/TypeSmsCollection'
import {ListTypeSmsSchema} from '@/schema/resource/TypeSms/ListTypeSmsSchema'
import {CsvTypeSmsSchema} from '@/schema/resource/TypeSms/CsvTypeSmsSchema'

@Component
export default class ListTypeSmsView extends Mixins(MixinQueryRouter) {
  schema = new ListTypeSmsSchema()
  collection = new TypeSmsCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: TypeSms) {
    Helper.pushByName('editTypeSms', item.$id)
  }

  async removeItem(item: TypeSms) {
    await new DialogRemove(item).confirm(() => item.removeTypeSms())
    await this.collection.listTypeSms()
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new TypeSmsCollection().clearFilters().addFilter(params)

    await csv.listCsvTypeSms()
    new CsvTypeSmsSchema().downloadCsv(csv.all())
  }
}
